import { render, staticRenderFns } from "./APIToken.vue?vue&type=template&id=2b18d8c1&scoped=true"
import script from "./APIToken.vue?vue&type=script&lang=js"
export * from "./APIToken.vue?vue&type=script&lang=js"
import style0 from "./APIToken.vue?vue&type=style&index=0&id=2b18d8c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18d8c1",
  null
  
)

/* custom blocks */
import block0 from "./APIToken.vue?vue&type=custom&index=0&blockType=v-card&class=customBorderRadius%20my-4"
if (typeof block0 === 'function') block0(component)

export default component.exports